// TODO(yo-tak): smart-apply-fe-console の定義に一本化する。

// AmbassadorのMappingリソースにより`/smart-apply/api/address/`というパスが`/api/`にrewriteされる
//https://github.com/graffer-inc/k8s-manifest/pull/22037#discussion_r1053036320
export const addressSearchBaseUrl = "/smart-apply/api/address/v3/search";
